import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function UMAlternativeCovSelector({attr, additionalOptions, dataType, mutuallyExclusive, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];
  
  let allOptions = getOptionsForAttr(attribute).list;

  if (additionalOptions && additionalOptions.length) {
    allOptions = [...allOptions, ...additionalOptions];
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = allOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });

    let disabled = false;
    let bi = line.biLimit;
    let umbi = line.umbiLimit;
    if(bi.includes("/") && umbi.includes("/")){
      if(lesserSplitValue(umbi, bi)){
        disabled = true;
      }
    } else {
      if(parseInt(umbi) < parseInt(bi)){
        disabled = true;
      }
    }
    let pd = line.pdLimit;
    let umpd = line.umpdLimit;
    if(pd.includes("/") && umpd.includes("/")){
      if(lesserSplitValue(umpd, pd)){
        disabled = true;
      }
    } else {
      if(parseInt(umpd) < parseInt(pd)){
        disabled = true;
      }
    }
    if(disabled == true){
      line.uMAlternativeCovInd = "No";
      props.value = "No";
    }

    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = formContext;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    
    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);

      actions.saveApplication();
    };

    return <Select
        {...props}
        isDisabled={disabled}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      options.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

function lesserSplitValue(val1, val2){
  let split1 = val1.split("/");
  let split1num1 = parseInt(split1[0]);
  let split1num2 = parseInt(split1[1]);
  let split2 = val2.split("/");
  let split2num1 = parseInt(split2[0]);
  let split2num2 = parseInt(split2[1]);
  if(split1num1 < split2num1 || split1num2 < split2num2) {
    return true;
  }
  return false;
}

function optionIsValid(optionValue, compValue){
  if( optionValue.includes('/') && compValue.includes('/') ) {
    const optionValueArray = optionValue.split('/');
    const compValueArray = compValue.split('/');
    if( parseInt(optionValueArray[0]) < parseInt(compValueArray[0]) ) {
      return true;
    }
    else if( parseInt(optionValueArray[0]) == parseInt(compValueArray[0]) ) {
      if( parseInt(optionValueArray[1]) <= parseInt(compValueArray[1]) ) {
        return true;
      }
    }
    return false;
  }
  else if( (optionValue.includes('/') && !compValue.includes('/')) || (!optionValue.includes('/') && compValue.includes('/')) ) {
    return false;
  }
  else {
    if( parseInt(optionValue) <= parseInt(compValue) ) {
      return true;
    }
    return false;
  }
  return false;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

UMAlternativeCovSelector.schema = BASIC_ELEMENT_SCHEMA;